import apiClient from "./apiClient";
import useUrlRedirect from "../../utility/hooks/useUrlRedirect";

function useConfigApiClient() {
  const redirectUrl = useUrlRedirect();

  apiClient.setHandleHttpErrorFn((response: any) => {
    redirectUrl("/error", {
      state: { code: response?.status },
    });
  });
}

export default useConfigApiClient;
